module.exports = __webpack_public_path__ + "static/media/scholarship-6.dd8a3545.jpg";